import { SocialProfileFindMany_socialProfileFindMany } from '../../graphql/SocialProfile/__generated__/SocialProfileFindMany'

export const filterSocialProfiles = (
  socialProfiles?: SocialProfileFindMany_socialProfileFindMany[]
) => {
  return socialProfiles?.filter((profile) => profile.status !== 'disconnected') || []
}
